import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockClosed = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.00006 9V7C5.00006 4.23858 7.23864 2 10.0001 2C12.7615 2 15.0001 4.23858 15.0001 7V9C16.1046 9 17.0001 9.89543 17.0001 11V16C17.0001 17.1046 16.1046 18 15.0001 18H5.00006C3.89549 18 3.00006 17.1046 3.00006 16V11C3.00006 9.89543 3.89549 9 5.00006 9ZM13.0001 7V9H7.00006V7C7.00006 5.34315 8.34321 4 10.0001 4C11.6569 4 13.0001 5.34315 13.0001 7Z",
		fill: "currentColor"
	})
});
export { SvgLockClosed as ReactComponent };
